var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"activity-icon",class:[("bg-size--" + _vm.bgSize),_vm.bgColor]},[_c('BaseIcon',{attrs:{"name":_vm.name,"color":_vm.color,"mode":_vm.mode,"size":_vm.size,"classes":_vm.classes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }